import GoodsTypeList from '@/views/goods/goods-type-list.vue';
import GoodsTypeDetail from '@/views/goods/goods-type-detail.vue';
import GoodsList from '@/views/goods/goods-list.vue';
import GoodsDetail from '@/views/goods/goods-detail.vue';
import GoodsTraceabilityList from '@/views/goods/goods-traceability-list.vue'
import GoodsTraceabilityDetail from '@/views/goods/detail/GoodsTraceabilityDetail.vue'
import GoodsCommentList from '@/views/goods/goods-comment.vue'

export default [{
		path: '/goods/goods-type-list',
		component: GoodsTypeList,
		name: 'goodsTypeList',
	},
	{
		path: '/goods/goods-type-detail',
		component: GoodsTypeDetail,
		name: 'goodsTypeDetail',
	},
	{
		path: '/goods/goods-list',
		component: GoodsList,
		name: 'goodsList',
	},
	{
		path: '/goods/goods-detail',
		component: GoodsDetail,
		name: 'goodsDetail',
	},
	{
		path: '/goods/goods-traceability-list',
		component: GoodsTraceabilityList,
		name: 'goodsTraceabilityList',
	},
	{
		path: '/goods/goods-goods-comment-list',
		component: GoodsCommentList,
		name: 'goodsCommentList',
	},
	{
		path: '/goods/goods-traceability-detail',
		component: GoodsTraceabilityDetail,
		name: 'goodsTraceabilityDetail',
	},
]
